<div class="toolbar">
  <app-toolbar>
    <div class="right">
      @if (item().telemetry.annotation?.text) {
        <app-button label="Remove" icon="mdi mdi-trash-can" (click)="annotationDelete()" />
      }
      <app-button icon="mdi mdi-check" label="Update" (click)="annotationSave()" />
    </div>
  </app-toolbar>
</div>
@if (item()) {
  <div class="annotation">
    <div>
      <p>
        Annotation at <strong>{{ item().telemetry.d | amDateFormat: 'ddd Do MMMM HH:mm' }}</strong> for value of
        <app-chip [label]="' ' + item().telemetry.v + ' '" />
      </p>
    </div>
    <div>
      <div><strong>Notes</strong></div>
      <textarea class="fourd" rows="5" [(ngModel)]="annotation.text"></textarea>
    </div>
  </div>
} @else {
  <i class="mdi mdi-loading mdi-spin-x2"></i>
}
